import React from "react";

import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";

const useStyles = makeStyles({
    button: {
        height: 50,
        width: "100%",
        color: "#ffffff",
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row",
        padding: 0,
        justifyContent: "flex-start",
        alignItems: "center",
    },
    icon: {
        width: 50,
        height: 50,
        backgroundColor: "rgba(0,0,0, 0.1)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    label: {
        flexGrow: 1,
    },
});

export interface UploadButtonProps {
    label: string;
    status: boolean;
    click: () => void;
}

const UploadButton: React.FC<UploadButtonProps> = ({
    label,
    status,
    click,
}) => {
    const css = useStyles();
    return (
        <Button
            variant="contained"
            size="large"
            color="secondary"
            classes={{ root: css.button }}
            onClick={click}
            disabled={status}
        >
            <div className={css.icon}>
                {status ? <CheckIcon /> : <AddIcon />}
            </div>
            <div className={css.label}>{label}</div>
        </Button>
    );
};

export default UploadButton;
